import { translate } from '../services/i18n.js';

export function element(tag, className = '', text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = translate(text);
  return node;
}
export function showMessage(target, message, retry) {
  const box = element('div', 'public-message'); box.setAttribute('role', 'status');
  box.appendChild(element('p', '', message));
  if (retry) {
    const button = element('button', 'filter-btn', 'Повторить загрузку'); button.type = 'button';
    button.addEventListener('click', retry); box.appendChild(button);
  }
  target.replaceChildren(box);
}
export function safePublicUrl(value) {
  try { const url = new URL(value); return ['http:', 'https:', 'mailto:'].includes(url.protocol) && !url.username && !url.password ? url.href : null; }
  catch { return null; }
}
